<mat-form-field
  class="select"
  [ngClass]="{
    'select-includes-icon': selectInludesIcon,
    'only-icon-select': displayMode === 'ICON'
  }"
  [class.panel-open]="select.panelOpen"
  [class.has-border]="hasBorder"
  appearance="outline">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select
    #select
    [placeholder]="placeholder"
    [multiple]="multiple"
    [formControl]="control"
    (selectionChange)="onSelectionChange($event)"
    panelClass="select-panel">
    <mat-select-trigger>
      <ng-container [ngSwitch]="displayMode">
        <span *ngSwitchCase="'TEXT'">
          {{ getSelectedOptionField('label') }}
        </span>
        <div class="img-container" *ngSwitchCase="'ICON'">
          <img [src]="control.value" />
        </div>
        <div *ngSwitchCase="'ICON_WITH_TEXT'" class="icon-with-text">
          <img [src]="getSelectedOptionField('icon')" />
          <span>{{ getSelectedOptionField('label') }}</span>
        </div>
      </ng-container>
    </mat-select-trigger>
    <mat-option
      *ngFor="let option of options"
      [value]="option[valueField]"
      [disabled]="_optionIsDisabled(option[valueField])"
      [ngClass]="{
        'option-includes-icon': selectInludesIcon,
        'only-icon-option': displayMode === 'ICON'
      }">
      <ng-container [ngSwitch]="displayMode">
        <span *ngSwitchCase="'TEXT'">{{ option[labelField] }}</span>
        <div class="img-container" *ngSwitchCase="'ICON'">
          <img [src]="option[iconField]" />
        </div>
        <div *ngSwitchCase="'ICON_WITH_TEXT'" class="icon-with-text">
          <div class="img-container">
            <img [src]="option[iconField]" />
          </div>
          <span>{{ option[labelField] }}</span>
        </div>
      </ng-container>
    </mat-option>
  </mat-select>
  <mat-icon matSuffix class="arrow-icon" svgIcon="back-icon">
    expand_more
  </mat-icon>
  <mat-error *ngIf="isInputInvalid() && displayErrorMessage">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>
